import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const MoreShowStory = (props) => {
  const { match } = props;

  return <ListStory page={Number(match.params.page)} type="showstories" />;
};

export default MoreShowStory;
